<!-- Standalone screen: Customers -> Reports -> Customer Payments. -->
<div class="main-content" *ngIf="menuapp">
	<div class="container-fluid">
		<mat-card class="feature-surface">
			<mat-card-header>
				<div mat-card-avatar class="feature-surface__icon">
					<i class="material-icons" aria-hidden="true">payments</i>
				</div>
				<mat-card-title>Customer Payments</mat-card-title>
				<mat-card-subtitle>
					Every payment taken in the range, and the invoices each one was applied to
				</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>
				<ng-container *ngTemplateOutlet="report"></ng-container>
			</mat-card-content>
		</mat-card>
	</div>
</div>

<!--
	Embedded in the customer view's Reports tab. The account is already chosen and
	the tab supplies the page chrome, so the card and its header drop away — only
	the report itself renders, titled like its sibling tabs.

	`.feature-surface` stays on the wrapper because the shared table styles are
	nested under it (shared/scss/_feature-surface.scss); the local .cpr-embedded
	rule strips the border and padding a real card would want.
-->
<div class="feature-surface cpr-embedded" *ngIf="!menuapp">
	<h3 class="text-left my-4">Customer Payments</h3>
	<ng-container *ngTemplateOutlet="report"></ng-container>
</div>

<ng-template #report>

				<form [formGroup]="filterForm" class="row mb-2">
					<div class="col-6 col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>From</mat-label>
							<input matInput type="date" formControlName="from">
						</mat-form-field>
					</div>
					<div class="col-6 col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>To</mat-label>
							<input matInput type="date" formControlName="to">
						</mat-form-field>
					</div>
					<div class="col-12 col-md-3" *ngIf="menuapp">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Customer</mat-label>
							<input matInput [formControl]="customerSearch" [matAutocomplete]="autoCustomer"
								placeholder="Name or account #" autocomplete="off">
							<mat-autocomplete #autoCustomer="matAutocomplete"
								(optionSelected)="pickCustomer($event.option.value)">
								<mat-option *ngFor="let c of customerResults" [value]="c">
									<strong>{{ c.debtorno }}</strong> — {{ c.name }}
								</mat-option>
							</mat-autocomplete>
							<mat-spinner matSuffix diameter="18" *ngIf="customerSearching"></mat-spinner>
							<button matSuffix mat-icon-button type="button" *ngIf="customer && !customerSearching"
								(click)="clearCustomer()" aria-label="Clear customer filter">
								<i class="material-icons" aria-hidden="true">close</i>
							</button>
						</mat-form-field>
					</div>
					<div class="col-6 col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Pay type</mat-label>
							<mat-select formControlName="paytype" multiple appSelectAll>
								<mat-option *ngFor="let p of paytypes" [value]="p.paytype">{{ p.paytype }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-6 col-md-3">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Check # / reference</mat-label>
							<input matInput formControlName="search" autocomplete="off"
								placeholder="Searches the whole range">
						</mat-form-field>
					</div>
					<div class="col-6 col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Documents</mat-label>
							<mat-select formControlName="doctype">
								<mat-option value="receipts">Receipts</mat-option>
								<mat-option value="credits">Credit notes</mat-option>
								<mat-option value="both">Receipts &amp; credits</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-6 col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Row cap</mat-label>
							<mat-select formControlName="limit">
								<mat-option *ngFor="let c of rowcaps" [value]="c">{{ c | number }} payments</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-12 col-md-3 d-flex align-items-center pb-3">
						<mat-checkbox formControlName="unappliedonly" color="accent">
							Unapplied cash only
						</mat-checkbox>
					</div>
				</form>

				<div class="d-flex mb-2 flex-wrap align-items-center" style="gap: 8px;">
					<button mat-flat-button color="accent" (click)="load()" [disabled]="loading">
						{{ loading ? 'Loading…' : 'Apply' }}
					</button>
					<button mat-stroked-button (click)="expandAll()" [disabled]="!searchresults.length">Expand all</button>
					<button mat-stroked-button (click)="collapseAll()" [disabled]="!anyExpanded">Collapse all</button>

					<span class="flex-grow-1"></span>

					<mat-form-field appearance="outline" class="cpr-quick-search">
						<mat-label>Quick search</mat-label>
						<input matInput type="search" autocomplete="off" [formControl]="searcher">
						<i matSuffix class="material-icons" aria-hidden="true">search</i>
					</mat-form-field>

					<button mat-icon-button (click)="exportXls()" [disabled]="exporting || !hasExportableRows"
						matTooltip="Export to Excel" aria-label="Export to Excel">
						<i class="material-icons" aria-hidden="true">grid_on</i>
					</button>
					<button mat-icon-button (click)="exportPdf()" [disabled]="exporting || !hasExportableRows"
						matTooltip="Export to PDF" aria-label="Export to PDF">
						<i class="material-icons" aria-hidden="true">picture_as_pdf</i>
					</button>
					<mat-progress-spinner *ngIf="exporting" diameter="20" mode="indeterminate" color="accent">
					</mat-progress-spinner>
				</div>

				<div *ngIf="errorMessage" class="feature-section mb-3">
					<p class="feature-section__title m-0">{{ errorMessage }}</p>
				</div>

				<div *ngIf="loading" class="text-center my-4">
					<mat-progress-spinner diameter="32" mode="indeterminate" color="accent"></mat-progress-spinner>
				</div>

				<ng-container *ngIf="!loading">

					<div class="feature-tile-row" *ngIf="displayTotals">
						<app-kpi-tile tone="accent" label="payments"
							[value]="displayTotals.payments | number"
							[sub]="accountsSub"></app-kpi-tile>
						<app-kpi-tile tone="accent" label="received"
							[value]="displayTotals.net | currency"></app-kpi-tile>
						<app-kpi-tile tone="settled" label="applied"
							[value]="displayTotals.applied | currency"></app-kpi-tile>
						<app-kpi-tile [tone]="displayTotals.unapplied ? 'partial' : 'settled'" label="on account"
							[value]="displayTotals.unapplied | currency"></app-kpi-tile>
					</div>

					<p *ngIf="searching" class="text-muted mt-2 mb-1" style="font-size: 12px;">
						showing {{ searchresults.length }} of {{ rows.length }} loaded payments
					</p>

					<div class="feature-table-scroll">
					<table class="feature-table feature-table--responsive">
						<thead>
							<tr>
								<th class="cpr-expand-col noprint"></th>
								<th>Id</th>
								<th><button class="sort-head" (click)="sortBy('date')">Date <i class="material-icons" aria-hidden="true">{{ sortIcon('date') }}</i></button></th>
								<th><button class="sort-head" (click)="sortBy('type')">Type <i class="material-icons" aria-hidden="true">{{ sortIcon('type') }}</i></button></th>
								<th><button class="sort-head" (click)="sortBy('account')">Account <i class="material-icons" aria-hidden="true">{{ sortIcon('account') }}</i></button></th>
								<th *ngIf="menuapp"><button class="sort-head" (click)="sortBy('customer')">Customer <i class="material-icons" aria-hidden="true">{{ sortIcon('customer') }}</i></button></th>
								<th><button class="sort-head" (click)="sortBy('payment')">Payment# <i class="material-icons" aria-hidden="true">{{ sortIcon('payment') }}</i></button></th>
								<th><button class="sort-head" (click)="sortBy('paytype')">Text/Order <i class="material-icons" aria-hidden="true">{{ sortIcon('paytype') }}</i></button></th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('net')">Net <i class="material-icons" aria-hidden="true">{{ sortIcon('net') }}</i></button></th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('applied')">Applied <i class="material-icons" aria-hidden="true">{{ sortIcon('applied') }}</i></button></th>
								<th class="is-num">Total Allocation</th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('unapplied')">Remainder <i class="material-icons" aria-hidden="true">{{ sortIcon('unapplied') }}</i></button></th>
								<th class="is-num" *ngIf="showBalance">Balance</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let r of searchresults">
								<tr class="cpr-payment" [class.is-open]="isExpanded(r)">
									<td class="cpr-expand-col noprint">
										<button mat-icon-button *ngIf="r.allocation_count" (click)="toggle(r)"
											[attr.aria-expanded]="isExpanded(r)"
											[attr.aria-label]="'Allocations for payment ' + r.transno">
											<i class="material-icons" aria-hidden="true">
												{{ isExpanded(r) ? 'expand_less' : 'expand_more' }}
											</i>
										</button>
									</td>
									<td data-label="Id">{{ r.id }}</td>
									<td data-label="Date">{{ r.trandate | date:'MM/dd/yyyy' }}</td>
									<td data-label="Type">{{ r.typename }}</td>
									<td data-label="Account">
										<a [routerLink]="['/customers/view', r.debtorno]">{{ r.debtorno }}</a>
									</td>
									<td data-label="Customer" class="cpr-clamp" *ngIf="menuapp"
										[title]="r.customer">{{ r.customer }}</td>
									<td data-label="Payment#">{{ r.transno }}</td>
									<td data-label="Text/Order" class="cpr-clamp" [class.cpr-blank]="!payRef(r)"
										[title]="payRef(r)">
										<span>{{ payRef(r) }}
											<div class="text-muted cpr-sub" *ngIf="r.allocation_count > 1">
												{{ r.allocation_count | number }} documents paid
											</div>
										</span>
									</td>
									<td data-label="Net" class="is-num">{{ r.net | currency }}</td>
									<td data-label="Applied" class="is-num">{{ r.applied | currency }}</td>
									<td data-label="Total Allocation" class="is-num cpr-blank"></td>
									<td data-label="Remainder" class="is-num"
										[class.cpr-open]="r.unapplied > 0.004"
										[class.cpr-zero]="isZero(r.unapplied)">{{ r.unapplied | currency }}</td>
									<td data-label="Balance" class="is-num" *ngIf="showBalance"
										[class.cpr-blank]="r.allocation_count < 2">{{ r.allocation_count > 1 ? (r.balance | currency) : '' }}</td>
								</tr>

								<tr class="cpr-alloc" *ngFor="let a of (isExpanded(r) ? r.allocations : [])">
									<td class="cpr-expand-col noprint cpr-blank"></td>
									<td data-label="Id">{{ a.doc_id }}</td>
									<td data-label="Date">{{ a.trandate | date:'MM/dd/yyyy' }}</td>
									<td data-label="Type">{{ a.typename }}</td>
									<td data-label="Account">{{ a.debtorno }}</td>
									<td data-label="Customer" class="cpr-blank" *ngIf="menuapp"></td>
									<td data-label="Payment#">{{ a.transno }}</td>
									<td data-label="Text/Order" [class.cpr-blank]="!(a.order_ > 1)">{{ a.order_ > 1 ? a.order_ : '' }}</td>
									<td data-label="Net" class="is-num">{{ a.net | currency }}</td>
									<td data-label="Applied" class="is-num">{{ a.applied | currency }}</td>
									<td data-label="Total Allocation" class="is-num" [class.cpr-zero]="isZero(a.total_alloc)">{{ a.total_alloc | currency }}</td>
									<td data-label="Remainder" class="is-num"
										[class.cpr-open]="a.remainder > 0.004"
										[class.cpr-zero]="isZero(a.remainder)">{{ a.remainder | currency }}</td>
									<td data-label="Balance" class="is-num" *ngIf="showBalance"
										[class.cpr-blank]="r.allocation_count < 2">{{ r.allocation_count > 1 ? (a.balance | currency) : '' }}</td>
								</tr>
							</ng-container>

							<tr *ngIf="!searchresults.length">
								<td [attr.colspan]="colCount" class="text-center text-muted">
									No payments in this range.
								</td>
							</tr>

							<tr class="is-total" *ngIf="searchresults.length && displayTotals">
								<td class="noprint cpr-blank"></td>
								<td [attr.colspan]="menuapp ? 7 : 6">{{ totalsLabel }}</td>
								<td data-label="Net" class="is-num">{{ displayTotals.net | currency }}</td>
								<td data-label="Applied" class="is-num">{{ displayTotals.applied | currency }}</td>
								<td class="is-num cpr-blank"></td>
								<td data-label="Remainder" class="is-num">{{ displayTotals.unapplied | currency }}</td>
								<td class="is-num cpr-blank" *ngIf="showBalance"></td>
							</tr>
						</tbody>
					</table>
					</div>

				</ng-container>

</ng-template>
